import { USER_PLACEHOLDERS } from '../texts/userPlaceholders';

interface PatternPreset {
  name: string;
  regex: string;
  message: string;
}

export const PATTERN_PRESETS: PatternPreset[] = [
  { name: 'Digits only', regex: '^\\d+$', message: USER_PLACEHOLDERS.pattern.digitsOnly },
  { name: 'Letters only', regex: '^\\p{L}+$', message: USER_PLACEHOLDERS.pattern.lettersOnly },
  { name: 'Latin letters only', regex: '^[A-Za-z]+$', message: USER_PLACEHOLDERS.pattern.latinLettersOnly },
];

export const patternPresetOf = (regex: string): PatternPreset | undefined => {
  return PATTERN_PRESETS.find(preset => preset.regex === regex);
};

export const patternCompiles = (regex: string): boolean => {
  return wholeValueMatcher(regex) !== undefined;
};

export const matchesPattern = (regex: string, value: string): boolean => {
  return wholeValueMatcher(regex)?.test(value.trim()) ?? false;
};

const wholeValueMatcher = (regex: string): RegExp | undefined => {
  try {
    const expression = new RegExp(regex, 'u');
    return new RegExp(`^(?:${expression.source})$`, 'u');
  } catch {
    return undefined;
  }
};
